import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';

import { AdresseDto } from 'src/graphql/generated-types';

import { BaseComponent } from 'src/app/_core/tools/base.component';

import { addressLines } from 'src/app/_shared/components/shared-address/shared-address-edit/shared-address-edit.component';

@Component({
    selector: 'app-shared-address-detail-component',
    templateUrl: 'shared-address-detail.component.html',
    styleUrls: ['shared-address-detail.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedAddressDetailComponent extends BaseComponent {

    private _address: AdresseDto = null;

    @Input()
    set address(address: AdresseDto) {
        this._address = address || null;

        this.addressLinesValues = Object.keys(addressLines).map(key => this.address?.[key]);
        this.cdr.markForCheck();
    }

    get address(): AdresseDto {
        return this._address;
    }

    addressLinesValues: string[] = [];

    constructor(protected readonly cdr: ChangeDetectorRef) {
        super(cdr);
    }
}
